import React from 'react';
import PropTypes from 'prop-types';

// Presentational Component
const WidgetMethods = ({ widgetName }) => {
	const vsWidgetName = `.VoiceStorm${widgetName}`;
	const exampleElementId = `#my${widgetName}`;

	return (
		<div className="widget-methods">
			<h3 id={`${vsWidgetName}-methods`}>Methods</h3>
			<h4><code>{vsWidgetName}(options)</code></h4>
			<p>Renders the widget into your element. Accepts an optional options <code>object</code>.</p>
			<pre className="language-javascript"><code className="language-javascript">{
				`$('${exampleElementId}')${vsWidgetName}({
	option: value
});`}
			</code></pre>
			<h4><code>{vsWidgetName}('option', 'name')</code></h4>
			<p>Returns the value of option 'name'.</p>
			<h4><code>{vsWidgetName}('option', 'name', value)</code></h4>
			<p>Sets option 'name' to <code>value</code>.</p>
			<h4><code>{vsWidgetName}('refresh')</code></h4>
			<p>Reloads the widget using the current options and data.</p>
		</div>
	);
};

WidgetMethods.propTypes = {
	widgetName: PropTypes.string.isRequired
};

export default WidgetMethods;












// WEBPACK FOOTER //
// ./src/components/widgets/WidgetMethods.js